<!--
  A window with a shaded box filling it. It means the record opens on its own
  page. It is drawn in outline, and the part the record takes is shaded at 35%
  opacity, like the side peek icon.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-slot="icon"
    data-icon="full-page"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <rect x="5.5" y="6.5" width="13" height="11" rx="1" fill="currentColor" fill-opacity="0.35" stroke="none" />
  </svg>
</template>
